import {
    Button,
    DatePicker,
    Form,
    Input,
    Select,
    Table,
    Upload,
} from "antd";
import React, { useEffect, useState } from "react";
import {
    dispatchtoast,
    filterOption,
} from "../../../../../Utils";
import { AiOutlineBank } from "react-icons/ai";
import { BsQrCode } from "react-icons/bs";
import {
    GetAdminBankDetail,
    SubmitDisputeRequest,
    getBanks,
} from "../../../../../ApiServices/Apifun";
import { IoCloudUploadOutline } from "react-icons/io5";
import { useForm } from "antd/es/form/Form";
import dayjs from "dayjs";
import { setselectedTab } from "../../../../../Store/B2bslice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import CommonInput from "../../../../../Common/CommonInput";

const DisputeRequest = () => {
    const [form] = useForm();
    const [btnLoading, setBtnLoading] = useState(false);
    const [activeTab, setActiveTab] = useState(1);
    const [fromBank, setFromBank] = useState([]);
    const [toBank, setToBank] = useState(false);
    const [bankData, setBankData] = useState([]);
    const [bankUpiDetail, setBankUpiDetail] = useState({});
    const [image, setImage] = useState([]);
    const [disableToBank, setDisableTobank] = useState(false)
    const [imageBase64, setImageBase64] = useState(false);
    const dispatch = useDispatch()
    const navigate = useNavigate()


    const handleFinish = (val) => {
        setBtnLoading(true)
        const formdata = new FormData();
        let data = { ...val };
        delete data["attachment"];

        formdata.append("attachment", imageBase64);
        Object.keys(data).map((key) => formdata.append(key, data[key]));
        SubmitDisputeRequest(formdata)
            .then((res) => {
                if (res.status) {
                    form.resetFields()
                    dispatchtoast(res.message);
                    navigate("/Report/dispute-request")
                }
            })
            .catch((err) => console.log(err)).finally(() => setBtnLoading(false))
    };
    const handleCustomReq = async ({ file, onSuccess, onError }) => {
        try {
            const base64Data = await readFileAsBase64(file);
            const dataUrl = await readFileAsDataUrl(file);
            const newFile = {
                ...file,
                name: file.name,
                thumbUrl: dataUrl,
                base64: base64Data,
            };
            setImage([newFile]);
            setImageBase64(base64Data);
            onSuccess();
        } catch (error) {
            console.error(error);
            onError(error);
        }
    };
    const readFileAsDataUrl = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                resolve(reader.result);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    };
    // Helper function to read a file as Base64 data
    const readFileAsBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                const base64Data = reader.result; // Remove the data URI prefix
                resolve(base64Data);
            };
            reader.onerror = (error) => {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    };
    return (
        <>
            <div className="grid grid-cols-1 md:grid-cols-1 gap-4 place-items-start">
                <div className="prepaid animate-slide-in w-full  bg-white shadow-normal  rounded-3xl p-5">
                    <p className="font-bold text-[15px] mb-2">Send Add Dispute Request</p>
                    <Form
                        form={form}
                        name="basic"
                        initialValues={{
                            remember: true,
                        }}
                        onFinishFailed={(err) => console.log(err)}
                        onFinish={(val) => handleFinish(val)}
                    >
                        <div className="w-full grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 place-items-start">
                            <Form.Item
                                name={`subject`}
                                label={"Subject"}
                                className="w-full"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: true,
                                        message: "Enter subject!",
                                    },
                                    {
                                        whitespace: true,
                                        message: "Field cannot contain only blank spaces",
                                    },
                                ]}
                            >
                                <CommonInput
                                    onInput={(e) => {
                                        const value = e.target.value
                                        e.target.value = value;
                                    }}
                                    placeholder="Enter Subject"
                                    name="subject"
                                />
                            </Form.Item>{" "}
                            <Form.Item
                                name={`description`}
                                label={"Description"}
                                className="w-full"
                                labelCol={{ span: 24 }}

                                rules={[
                                    {
                                        required: true,
                                        message: "Enter description!",
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    placeholder="Enter description"
                                    name="description"
                                    rows={1}


                                    className="outline-none text-xs border  w-full border-gray-200 focus:border-primary  h-9 px-2 "
                                />
                            </Form.Item>

                            <Form.Item
                                name={`attachment`}
                                label={"Dispute Proof Image"}
                                className="w-full"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                        required: false,
                                        message: "Upload one Dispute proof!",
                                    },
                                ]}
                            >
                                <Upload
                                    maxCount={1}
                                    onRemove={() => {
                                        setImage([])
                                    }}
                                    listType="picture"
                                    accept=".jpg, .jpeg, .png"
                                    fileList={image}
                                    customRequest={handleCustomReq}
                                >
                                    <Button
                                        className="bg-primary text-white border-none font-medium"
                                        icon={<IoCloudUploadOutline />}
                                    >
                                        Click to Upload
                                    </Button>
                                </Upload>
                            </Form.Item>



                        </div>
                        <div className="flex justify-end items-center ">
                            <Form.Item>
                                <Button
                                    loading={btnLoading}
                                    className="w-full bg-primary border-none mt-4"
                                    style={{ color: "white" }}
                                    htmlType="submit"
                                >
                                    Send
                                </Button>
                            </Form.Item>
                        </div>
                    </Form>
                </div>

            </div>
        </>
    );
};

export default DisputeRequest;
